import HeroStyle5 from '../Hero/HeroStyle5';
import Cta from '../Cta';
import Spacing from '../Spacing';
import SectionHeading from '../SectionHeading';
import WelcomePopup from '../popup/PopUp';
import TestimonialSliderStyle2 from '../Slider/TestimonialSliderStyle2';
import FunFact from '../FunFact';
import VideoModal from '../VideoModal';
import IconboxStyle4 from '../IconBox/IconboxStyle4';
import Card from '../Card';
import CardStyle2 from '../Card/CardStyle2';
import SectionHeadingStyle2 from '../SectionHeading/SectionHeadingStyle2';
import IconBoxStyle5 from '../IconBox/IconBoxStyle5';

import { pageTitle } from '../../helpers/PageTitle';

const funfactData = [
  { title: 'Active Deployments', number: '15+' }, // replace with real metric
  { title: 'Projects Delivered', number: '40+' }, // replace with real metric
  { title: 'Team Experts', number: '7+' }, // replace with real metric
  { title: 'Industries Served', number: '4+' }, // replace with real metric
];

const testimonialData = [
  {
    text: 'Ranads built our headless CMS and automated WhatsApp flows. Sales follow ups are instant, reporting is real time, and content deploys in minutes.',
    avatarName: 'Operations Director',
    avatarDesignation: 'Retail & Services',
  },
  {
    text: 'Their React + NestJS stack is rock-solid. We got a clean architecture, fast UI, and an admin that our team actually loves to use.',
    avatarName: 'Product Lead',
    avatarDesignation: 'Tech Company',
  },
  {
    text: 'The WhatsApp Business API suite from Ranads plugged perfectly into our CRM and reduced manual work significantly.',
    avatarName: 'Growth Manager',
    avatarDesignation: 'Healthcare Services',
  },
];

export default function TechStartupPage() {
  pageTitle('Ranads — Digital Systems & AI');

  // Optional inline theme hooks using your colors in wrapper sections
  const darkBg = { backgroundColor: '#1a1a1a' };

  return (
    <>
      {/* <WelcomePopup latestUrl='https://bythesky.com' /> */}

      <HeroStyle5
        highlightTitle='End to End CMS • ERP • WhatsApp Business API'
        title={'Build smarter products with <br />Ranads'}
        subTitle={
          'We design, ship, and scale full-stack systems using <b>React</b> and <b>NestJS</b>, integrate the <b>WhatsApp Business API</b>, and embed the latest <b>LLM/AI</b> workflows,so your content and sales move faster together.'
        }
        // btnText='See Our Work'
        // btnUrl='/portfolio'
        // videoSrc='https://www.youtube.com/embed/VcaAVWtP48A'
        // videoBtnText='Play Video'
      />

      {/* Brand strip */}
      {/* <div className='cs_primary_bg' style={darkBg}>
        <Spacing lg='95' md='60' />
        <div className='container'>
          <BrandCarousel data={brandData} />
        </div>
        <Spacing lg='95' md='60' />
      </div> */}

      {/* What we do */}
      <section>
        <Spacing lg='143' md='75' />
        <div className='container'>
          <SectionHeading
            title={'We design, build & scale <br />digital systems for growth'}
            subTitle='What We Do'
            variant='cs_type_1'
          />
          <Spacing lg='85' md='45' />
          <div className='row g-3'>
            <div className='col-lg-6'>
              <IconboxStyle4
                iconSrc='/images/tech-startup/feature_icon_1.svg'
                title='Data & analytics foundation'
                subTitle='From PostgreSQL schemas to event tracking and dashboards—clean data models, meaningful metrics, and decision-ready reporting.'
                btnText='Learn More'
                btnUrl='/service'
              />
            </div>
            <div className='col-lg-6'>
              <IconboxStyle4
                iconSrc='/images/tech-startup/feature_icon_2.svg'
                title='Omnichannel automations'
                subTitle='Build a comprehensive WhatsApp Business solution featuring automated conversation flows powered by the WhatsApp Business API.'
                btnText='Learn More'
                btnUrl='/service'
              />
            </div>
            <div className='col-lg-6'>
              <IconboxStyle4
                iconSrc='/images/tech-startup/feature_icon_3.svg'
                title='ERP & operations OS'
                subTitle='Build custom modules for inventory management, order processing, task automation, approval workflows, and SLA tracking—powered by NestJS services and distributed worker queues.'
                btnText='Learn More'
                btnUrl='/service'
              />
            </div>
            <div className='col-lg-6'>
              <IconboxStyle4
                iconSrc='/images/tech-startup/service_icon_4.svg'
                title='Web & headless CMS'
                subTitle='Build high-performance React frontends integrated with a flexible, editor-friendly CMS—optimized for SEO, multi-language localization, and rapid content publishing workflows.'
                btnText='Learn More'
                btnUrl='/service'
              />
            </div>
          </div>
        </div>
        <Spacing lg='150' md='80' />
      </section>

      {/* About Ranads */}
      <section className='cs_primary_bg' style={darkBg}>
        <Spacing lg='143' md='75' />
        <div className='container'>
          <SectionHeadingStyle2
            title={
              'Systems that connect, automate,<br />and grow with your business.'
            }
            subTitle='About Ranads'
            btnText='Learn More'
            btnUrl='/about'
          />
          <Spacing lg='85' md='45' />
          <div className='row g-3'>
            <div className='col-lg-12'>
              <Card
                thumbnailSrc='/images/home/home2.avif'
                title='Ship reliable platforms that make sales, service & ops faster.'
                miniTitle='Our Goal'
              />
            </div>
            <div className='col-lg-6'>
              <CardStyle2
                miniTitle='Our Mission'
                title='Build delightful, scalable products with React & NestJS.'
                subTitle='We combine clean architecture, strong DX, and pragmatic DevOps so teams can launch quickly, iterate safely, and scale confidently.'
                variant='cs_mission'
              />
            </div>
            <div className='col-lg-6'>
              <CardStyle2
                miniTitle='Our Vision'
                title='LLM-powered workflows for every team.'
                subTitle='From AI assistants to smart routing and summarization LLMs accelerate content ops, customer care, analytics, and beyond.'
                variant='cs_vision'
              />
            </div>
          </div>
        </div>
        <Spacing lg='150' md='80' />
      </section>

      {/* Services */}
      <section>
        <Spacing lg='143' md='75' />
        <div className='container'>
          <SectionHeading
            title={
              'From idea to production ready <br />systems shipped with care'
            }
            subTitle='Services'
            variant='cs_type_1'
          />
          <Spacing lg='85' md='45' />
          <div className='row g-3'>
            <div className='col-lg-6 col-xl-3'>
              <IconBoxStyle5
                iconSrc='/images/tech-startup/service_icon_1.svg'
                title='WhatsApp API Suite'
                subTitle='Flows, templates, webhooks, and analytics integrated with your CRM/ERP built for speed and reliability.'
                href='/service-details'
              />
            </div>
            <div className='col-lg-6 col-xl-3'>
              <IconBoxStyle5
                iconSrc='/images/tech-startup/service_icon_2.svg'
                title='Headless CMS & Websites'
                subTitle='React frontends, editor-friendly backends,and SEO foundations that actually rank.'
                href='/service-details'
              />
            </div>
            <div className='col-lg-6 col-xl-3'>
              <IconBoxStyle5
                iconSrc='/images/tech-startup/service_icon_3.svg'
                title='ERP & Dashboards'
                subTitle='Custom modules, role-based access, and clear dashboards for operations, finance, and growth teams.'
                href='/service-details'
              />
            </div>
            <div className='col-lg-6 col-xl-3'>
              <IconBoxStyle5
                iconSrc='/images/tech-startup/service_icon_4.svg'
                title='AI Assistants & LLMs'
                subTitle='Task-specific agents for support, sales, QA, and content—grounded, auditable, and production-ready.'
                href='/service-details'
              />
            </div>
          </div>
        </div>
      </section>

      {/* Studio / video */}
      <div className='container'>
        <Spacing lg='130' md='70' />
        <VideoModal
          videoSrc='/images/home/homeVideo.mp4'
          bgUrl='/images/home/home3.avif'
          title={
            'We turn ideas into production ready<br />platforms your team can trust'
          }
          titleVariant='cs_outline_text'
        />
      </div>

      {/* Metrics */}
      <Spacing lg='125' md='70' />
      <div className='container'>
        <FunFact data={funfactData} />
      </div>
      <Spacing lg='125' md='70' />

      {/* Testimonials */}
      <TestimonialSliderStyle2 data={testimonialData} />

      {/* Pricing */}
      {/* <section className='cs_shape_animation_2'>
        <div className='cs_shape_1 position-absolute'>
          <svg
            width={57}
            height={41}
            viewBox='0 0 57 41'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              opacity='0.5'
              d='M55.1923 32.7347C52.209 37.0618 42.704 43.3879 40.3199 34.8097C39.0585 30.2359 42.6536 24.5172 43.1266 19.9687C43.8204 13.2821 39.973 5.41874 32.4359 6.05135C31.8886 6.10385 31.3452 6.19047 30.8086 6.31072C29.5308 4.21019 27.6918 2.5107 25.5002 1.40489C23.3085 0.299087 20.8519 -0.168816 18.4087 0.0542238C11.0797 0.743766 5.31489 7.39247 2.40097 13.6616C0.297443 17.9159 -0.0470809 22.831 1.44227 27.3386C2.02253 28.9897 4.52649 28.3381 4.07868 26.6111C2.33789 19.994 6.55742 12.4976 11.1238 7.99978C15.6903 3.50194 23.1517 2.572 26.8919 7.71511C22.3191 9.96086 18.2321 14.1614 15.6019 17.957C12.4483 22.5245 9.15598 31.3746 15.1794 35.2589C21.0135 39.0165 27.7181 36.5241 30.9852 30.8306C34.3217 24.9727 34.2461 16.9828 32.6377 10.6251C32.4379 9.84013 32.1764 9.07227 31.8556 8.32873C34.7948 7.65817 37.6078 8.80319 39.4747 11.7765C42.4517 16.502 40.9317 21.6009 39.5126 26.5289C38.1691 31.1785 36.6617 38.618 42.9185 40.5728C48.4057 42.2935 54.6246 38.6054 56.4853 33.2978C56.7691 32.507 55.6275 32.1085 55.1923 32.7347ZM27.8253 28.0345C26.6396 30.7231 24.5519 32.7537 21.5181 32.9751C16.3336 33.3547 15.3434 29.0909 16.4723 25.0739C18.1122 19.3298 23.2274 13.4845 28.1407 10.0684C28.1664 10.1199 28.1896 10.1727 28.2101 10.2266C30.2749 16.0071 30.1378 22.349 27.8253 28.0345Z'
              fill='#4F4747'
            />
          </svg>
        </div>
        <div className='cs_shape_2 position-absolute'>
          <svg
            width={21}
            height={24}
            viewBox='0 0 21 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              opacity='0.5'
              d='M1.83883 0.992714L20.9086 13.6609L0.402728 23.8417L1.83883 0.992714Z'
              fill='#4F4747'
            />
          </svg>
        </div>
        <Spacing lg='143' md='75' />
        <div className='container'>
          <SectionHeading
            title={'Simple, transparent plans <br />that scale with your needs'}
            subTitle='Our Pricing'
            variant='cs_type_1'
          />
          <Spacing lg='85' md='45' />
        </div>
        <div className='container'>
          <PricingTableList />
        </div>
        <div className='cs_height_150 cs_height_lg_80' />
      </section> */}

      {/* Blog */}
      {/* <section className='cs_p76_full_width cs_gray_bg_2'>
        <Spacing lg='143' md='75' />
        <div className='container'>
          <SectionHeading
            title={
              'Notes from the build room:<br />engineering, product, and AI'
            }
            subTitle='Our Blog'
            variant='cs_type_1'
          />
          <Spacing lg='85' md='45' />
        </div>
        <PostCarousel data={postData} />
        <Spacing lg='150' md='80' />
      </section> */}

      {/* CTA */}
      <section>
        <Spacing lg='150' md='80' />
        <div className='container'>
          <Cta
            title='Have a platform in mind? Let’s plan the build.'
            btnText='Contact Us'
            btnUrl='/contact'
            bgUrl='/images/tech-startup/cta_bg.jpeg'
            noShape
          />
        </div>
        <Spacing lg='150' md='80' />
      </section>
    </>
  );
}
